<template>
  <div>
    <div class="row" >
       <div  class="col-12">

        <div class="sticky-settings">
          <div  @click="toggleOeeFilter()" class="toggle-filter-btn">
            <div class="toggle-button">
              <i class="fal fa-cog portlet-icon toggle-icon"></i>
            </div>
          </div>
          <div class="slide-over-panel-right" style=" ">

            <Filters
                @updateData="updateData = $event"
                @closePortletClicked="toggleOeeFilter"  :show-close-button="filterOpen"></Filters>
          </div>
        </div>
          <div v-show="updateData">
            <OeeCharts :updateDataTrigger="updateData"/>
            <ProductionRunsTable :updateDataTrigger="updateData"/>
            <DownTimes :updateDataTrigger="updateData"/>
            <Performance :updateDataTrigger="updateData" />
          </div>
      </div>

      <template v-if="!updateData">
        <div class="col-12" >
          <div class="no-date-range-selected">
            <i class="fas fa-info-circle"></i>
            {{ $t('oeeAnalytics.oeeCharts.noDateRangeSelected') }}
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import OeeCharts from "@/components/oeeAnalytics/OeeCharts";
import DownTimes from "@/components/oeeAnalytics/DownTimes";
import Performance from '@/components/oeeAnalytics/Performance';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {mapGetters} from "vuex";
import Filters from '@/components/oeeAnalytics/Filters';
import ProductionRunsTable from "@/components/oeeAnalytics/components/jobs/ProductionRunsTable";

export default {
  name: "OeeAnalytics",
  components: {
    ProductionRunsTable,
    OeeCharts, DownTimes, Performance, Filters
  },
  data() {
    return {
      updateData:null,
      productionRuns:null,
      filterOpen: true,
    }
  },
  computed: {
    ...mapGetters('workflows', [
      'getWorkflows']),
    ...mapGetters('oeeAnalytics', ['getWorkflowId', 'getSelectedDate', 'getUnit', 'getDateRange']),
    ...mapGetters('company', ['getOeeConfig'])

  },
  methods: {
    setProductionRuns(event){
      this.productionRuns = event
    },
    toggleOeeFilter() {
      this.filterOpen = !this.filterOpen;
      $(".slide-over-panel-right").animate({width:'toggle'}, 100);
    }
  },
  created(){

  }
}
</script>

<style >
.no-date-range-selected {
  border: 1px solid #00c9ff;
  padding: 2rem;
  background-color: #ebfcfd;
  margin-top: 2rem;
}

.settings-row > div, button {
  margin-bottom: 1rem;
}

.sticky-settings {
  position: sticky;
  top: 90px;
  z-index: 9999;
}

.btn-wrap {
  white-space: normal;
}
</style>

<style>
.right-aligned-calendar > .vdp-datepicker__calendar {
  right: 0px
}

.right-aligned-calendar > .vdp-datepicker__calendar:before {
  display: none;
}

.filter-bttn {
  width: 100%;
}

.slide-over-panel-right {
  width: 300px;
  position: absolute;
  right: -40px;
  top: -30px;
  z-index: 999999;
  height: 100vh;
  -webkit-box-shadow: -17px 1px 21px -8px rgba(0,0,0,0.59);
  box-shadow: -17px 1px 21px -8px rgba(0,0,0,0.59);
}

.slide-over-panel-right > div {
  height: 100%;
}



.toggle-filter-btn {
  z-index: 999;
  cursor: pointer;
  font-size: 3rem;
  color: #00c9ff;
  position: fixed;
  right: 0;
  top: calc(20% - 3rem);
  background-color: #fcfcfc;
  box-shadow: 0px 3px 15px rgba(0,0,0,0.2);

  -webkit-border-top-left-radius: 10px;
  -webkit-border-bottom-left-radius: 10px;
  -moz-border-radius-topleft: 10px;
  -moz-border-radius-bottomleft: 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  /*border: 1px solid #00c9ff;*/
  width: 6rem;
  height: 6rem;
  border-right: 0px;
  display: grid;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-items: center;
  -webkit-animation: slide-in-right 0.1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 100ms both;
  animation: slide-in-right 0.1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 100ms both;
}

/* ----------------------------------------------
 * Generated by Animista on 2022-3-15 15:31:12
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-in-right
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

</style>

